"use client";

import Link from "next/link";
import { useState } from "react";
import { FaArrowLeft, FaEnvelope, FaPaperPlane } from "react-icons/fa";

export default function RecuperarSenhaPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await fetch("/api/auth/password/forgot", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = (await response.json().catch(() => ({}))) as {
        success?: boolean;
        message?: string;
        error?: string;
      };

      if (!response.ok || data.success === false) {
        setError(data.error || "Não foi possível enviar o e-mail de recuperação agora.");
        return;
      }

      setMessage(
        data.message ||
          "Se o e-mail estiver cadastrado, você receberá as instruções de recuperação em instantes.",
      );
    } catch (requestError) {
      console.error(requestError);
      setError("Não foi possível concluir a solicitação agora. Tente novamente em instantes.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full rounded-xl border border-gray-600/80 bg-gray-900/70 py-2.5 pl-10 pr-3 text-sm text-gray-100 placeholder-gray-400 transition focus:border-cyan-400/60 focus:outline-none focus:ring-4 focus:ring-cyan-500/15";

  return (
    <div className="relative min-h-screen overflow-hidden bg-linear-to-br from-gray-950 via-gray-900 to-slate-950 text-white">
      <span className="pointer-events-none absolute -top-24 -right-14 h-72 w-72 rounded-full bg-cyan-500/15 blur-3xl" />
      <span className="pointer-events-none absolute -bottom-28 left-1/4 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
      <div className="relative mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center px-4 py-8 sm:px-6">
        <section className="relative w-full max-w-md overflow-hidden rounded-3xl border border-cyan-500/20 bg-linear-to-br from-gray-900 via-slate-900 to-gray-900 p-6 shadow-2xl shadow-black/30 sm:p-8">
          <div className="relative">
            <div className="mb-6">
              <h1 className="text-2xl font-semibold">Recuperar senha</h1>
              <p className="mt-1 text-sm text-gray-400">Informe seu e-mail para receber o link de redefinição.</p>
            </div>
            <form className="space-y-5" onSubmit={handleSubmit}>
              <div>
                <label className="mb-1.5 block text-sm text-gray-200" htmlFor="email">E-mail</label>
                <div className="relative">
                  <FaEnvelope className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-cyan-300/80" />
                  <input id="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} className={inputClass} placeholder="seu@email.com" autoComplete="email" required />
                </div>
              </div>
              {error ? <p className="rounded-lg border border-red-500/35 bg-red-500/10 px-3 py-2 text-sm text-red-200">{error}</p> : null}
              {message ? <p className="rounded-lg border border-emerald-500/35 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-200">{message}</p> : null}
              <button type="submit" disabled={loading} className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-cyan-400/35 bg-cyan-500/20 px-4 py-2.5 text-sm font-semibold text-cyan-100 transition hover:border-cyan-300/60 hover:bg-cyan-500/30 disabled:cursor-not-allowed disabled:opacity-60">
                {loading ? "Enviando..." : "Enviar link de recuperação"}
                {!loading ? <FaPaperPlane className="text-xs" /> : null}
              </button>
            </form>
            <div className="mt-5"><Link href="/login" className="inline-flex items-center gap-2 text-sm text-cyan-200 transition hover:text-cyan-100"><FaArrowLeft className="text-xs" />Voltar para o login</Link></div>
          </div>
        </section>
      </div>
    </div>
  );
}
